import React, {useEffect, useState} from "react";
import Avatar from "../../../assets/img/avatar.png";
import {useSelector} from "react-redux";
import {selectProfileInfo} from "../../../store/selectors/Profile";
import Toast from "../Toast";
import ToastMessage from "../ToastMessage";

const UploadContainer = ({ setFile }) => {

  const profileInfo = useSelector(selectProfileInfo);
  const [preview, setPreview] = useState(profileInfo.avatar);

  useEffect(() => {
    setPreview(profileInfo.avatar)
  }, [profileInfo.avatar])

  const handleChange = (event) => {
    const myRegex = /[\/.](jpg|jpeg|png)$/i;
    if (myRegex.test(event.target.files[0].type) && event.target.files[0].size <= 2000000) {
      setFile(event.target.files[0]);
      setPreview(URL.createObjectURL(event.target.files[0]))
    }else {
      Toast(ToastMessage(3), "error")
    }
  };

  return (
    <div className={"uploadContainer"}>
      {
        preview ?
          (<img className={"avatar"} src={preview} alt={'Avatar'}/>)
        :
          (<div className={"avatar preview"}>
            <img
              className={"previewImg"}
              src={Avatar}
              alt="Preview"
            />
          </div>)
      }
      <input id="img" className={"hiddenInput"} type="file" onChange={handleChange} />
      <label className={"EMPHASIS_SMALL inputLabel"} htmlFor="img">Upload Image</label>
    </div>
  );
}

export default UploadContainer;
